import { LocationSort, POINT_TYPES, PointType } from './locationBrowse';

export const LOCATION_PREFERENCES_KEY = 'totupoint.locationPreferences.v1';

export interface LocationPreferences {
    types: PointType[];
    sort: LocationSort;
}

export const readLocationPreferences = (): LocationPreferences => {
    const defaults: LocationPreferences = { types: ['wireless'], sort: 'distance' };
    try {
        const saved = JSON.parse(window.localStorage.getItem(LOCATION_PREFERENCES_KEY) || 'null');
        if (!saved || typeof saved !== 'object' || Array.isArray(saved)) return defaults;
        return {
            types: Array.isArray(saved.types) && saved.types.every((type: unknown) => POINT_TYPES.includes(type as PointType))
                ? POINT_TYPES.filter(type => saved.types.includes(type)) : defaults.types,
            sort: saved.sort === 'alphabetical' || saved.sort === 'distance' || saved.sort === 'installationDate'
                ? saved.sort : defaults.sort,
        };
    } catch {
        return defaults;
    }
};

export const writeLocationPreferences = (preferences: LocationPreferences) => {
    try {
        window.localStorage.setItem(LOCATION_PREFERENCES_KEY, JSON.stringify(preferences));
    } catch {
    }
};
